import { formatNumber } from "./formatters.ts";

export function AdminKpi({
  label,
  value,
  suffix = "",
  loading,
}: {
  label: string;
  value?: number;
  suffix?: string;
  loading: boolean;
}) {
  return (
    <article className="admin-kpi">
      <span>{label}</span>
      <strong>{loading ? "--" : `${formatNumber(value)}${suffix}`}</strong>
    </article>
  );
}
